<template>
  <div class="form-group col-md-6 offset-md-3 col-sm-12" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="200">
    <p class="text-center"><span><i class="fal fa-info-circle"></i> {{ $t('for_more_info') }} <a :href="companyPhoneHref">{{ companyPhone }}</a></span></p>
  </div>
</template>
<script>
  import company_phone_mixin from '@/shared/company_phone_mixin'
  export default {
    mixins: [company_phone_mixin]
  }
</script>
